import { CallIntelUtils } from '@frontend/api-call-intel';
import { getUser } from '@frontend/auth-helpers';
import { useIsCallIntelEligibleAccount } from '@frontend/call-intel-core';

export const useShowCallIntelNav = () => {
  const { isCallIntelEligibleAccount, isCallIntelActive } = useIsCallIntelEligibleAccount();

  const isDemoUserFlag = CallIntelUtils.isDemoUser(getUser()?.username);

  return isCallIntelActive || isCallIntelEligibleAccount || isDemoUserFlag;
};
